import { useContext } from 'react'

import { CONTENT_TYPES } from '@scoir/college-content'

import { FIELD_NAMES, LABELS } from '../../components/constants'
import ContentModalContext from '../../ContentModalProvider/Context'

import Section from '../../components/Section'
import ImageUpload from './ImageUpload'
import Recurrence from './Recurrence'
import AltText from './AltText'
import Title from './Title'
import DateSelector from './DateTimeSelector'
import VideoLink from './VideoLink'
import Description from './Description'
import RegistrationLink from '../Type/RegistrationLink'
import Season from './Season'
import CardPreview from '../CardPreview'
import { SectionTitle } from '@scoir/headers'

interface DetailsProps {
  onToggleEnforceFocus?: () => void
}

const Details = ({ onToggleEnforceFocus }: DetailsProps) => {
  const { type } = useContext(ContentModalContext)

  return (
    <Section title="Preview">
      <CardPreview />
      <SectionTitle title="Details" />
      <Title />
      <ImageUpload />
      <AltText />
      {type !== CONTENT_TYPES.SESSIONS && <VideoLink />}
      {type === CONTENT_TYPES.SESSIONS && (
        <>
          <Recurrence />
          <DateSelector />
        </>
      )}
      {type === CONTENT_TYPES.PROGRAMS && <Season />}
      <Description onToggleEnforceFocus={onToggleEnforceFocus} />
      {type === CONTENT_TYPES.PROGRAMS && (
        <RegistrationLink
          label={LABELS.PROGRAM_WEBSITE}
          fieldName={FIELD_NAMES.LINK}
          helperText='This will appear as a "Learn More" button.'
        />
      )}
    </Section>
  )
}

export default Details
